import React from 'react'
import Footer from '../Footer'
import Uml5 from '../Uml5'

function Umass5() {
    window.scrollTo(0,0);
    return (
        <div>
            <Uml5/>
            <Footer/>
        </div>
    )
}

export default Umass5
